import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CENCustomCategoriesFilterPropertiesState from "@tCentro/Store/Reducer/CENCustomCategoriesFilterPropertiesState";
import { Draft } from "immer";

const initialState: CENCustomCategoriesFilterPropertiesState = {
    isIncludeSubCategoriesFlag: true,
};

const reducer = {
    "Custom/ProductList/CategoriesFilter/SetInitialValues": (
        draft: Draft<CENCustomCategoriesFilterPropertiesState>,
    ) => {
        draft.isIncludeSubCategoriesFlag = true;
    },

    "Custom/ProductList/CategoriesFilter": (
        draft: Draft<CENCustomCategoriesFilterPropertiesState>,
        action: {
            isIncludeSubCategoriesFlag: boolean;
        },
    ) => {
        draft.isIncludeSubCategoriesFlag = action.isIncludeSubCategoriesFlag;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
